document.addEventListener('DOMContentLoaded', function() {
  // Função para sincronizar os sliders
  function syncSliders() {
    const headerSlider = document.querySelector('.bls__section-header .tns-controls');
    const productSlider = document.querySelector('.shopable-image-items .tns-controls');
    
    if (!headerSlider || !productSlider) return;

    // Adiciona listeners aos botões do header
    headerSlider.querySelectorAll('button').forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const direction = this.getAttribute('data-controls');
        
        // Encontra e clica no botão correspondente no slider de produtos
        const targetButton = productSlider.querySelector(`[data-controls="${direction}"]`);
        if (targetButton) {
          targetButton.click();
        }
      });
    });
  }

  // Inicializa a sincronização
  syncSliders();
});